import { render, staticRenderFns } from "./ProviderBasicInfo.vue?vue&type=template&id=14bcddca"
import script from "./ProviderBasicInfo.vue?vue&type=script&lang=js"
export * from "./ProviderBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports